import 'bootstrap/dist/js/bootstrap.bundle';
import { useContext } from 'react';
import { PersonCircle } from 'react-bootstrap-icons';
import { useHistory } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import AuthContext from '../store/auth-context';

const UserActionIcon = ({ color = 'gray', size = 35, logout, isLoggedIn }) => {
  const history = useHistory();
  const { isAdmin } = useContext(AuthContext);

  const taskSchedule = () => {
    history.push('/file-schedule');
  };

  const accountDetails = () => {
    history.push('/account-details');
  };

  const logoutUser = () => {
    logout();
  };

  const dashboard = () => {
    history.push('/home');
  };

  return (
    <>
      {isLoggedIn && (
        <Dropdown className="d-flex flex-row-reverse">
          <Dropdown.Toggle id="dropdown-basic" aria-label="user-icon-toggle">
            <PersonCircle className="rounded-circle" color={color} size={size} />
          </Dropdown.Toggle>
          <Dropdown.Menu aria-label="user-icon-dropdown">
            <Dropdown.Item onClick={dashboard}>Home</Dropdown.Item>
            <Dropdown.Item onClick={accountDetails}>Account Details</Dropdown.Item>
            {isAdmin && <Dropdown.Item onClick={taskSchedule}>File Schedule</Dropdown.Item>}
            <Dropdown.Item onClick={logoutUser}>Log Out</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
};

export default UserActionIcon;
